import {
  UpdateUserPayload,
  useUpdateUsers,
} from "@coworker/apprestructured/src/shared/hooks/users/useUpdateUsers";
import { useToastNotification } from "@coworker/components/src/components/ToastNotification";
import { useTranslation } from "@coworker/locales";

export type MoveUsersToTeamPayload = {
  users: UpdateUserPayload[];
};

export const useMoveUsersToTeam = () => {
  const { t } = useTranslation();
  const { showToast } = useToastNotification();

  const { mutateAsync: moveUsersToTeamRequest } = useUpdateUsers();

  const moveUsersToTeam = async ({ users }: MoveUsersToTeamPayload) => {
    try {
      await moveUsersToTeamRequest(users);
      showToast(t("movedNUsersToTeamString", { count: users.length }));
    } catch (error) {
      showToast(t("failedToMoveUsersToTeamString"));
      throw error;
    }
  };

  return { moveUsersToTeam };
};
